/**
 * Status Chip Component
 */
import { Chip, ChipProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { ORDER_STATUS_CONFIG, OrderStatus } from '../../types/order';

interface StatusChipProps extends Omit<ChipProps, 'color'> {
  status: OrderStatus;
}

const StatusChip = ({ status, ...props }: StatusChipProps) => {
  const { t } = useTranslation();
  const config = ORDER_STATUS_CONFIG[status] || { label: status, color: 'default' };
  const label = t(`components.status.${status}`, { defaultValue: config.label });

  return (
    <Chip
      label={label}
      color={config.color}
      size="small"
      {...props}
    />
  );
};

export default StatusChip;

